/* Lieferzeit-Eigenschaft beim Variantenwechsel nachziehen (DREA-3).
 *
 * WOZU: snippets/lbrgt-lieferzeit-eigenschaft.liquid legt ein verstecktes Feld
 * properties[Lieferzeit] ins Produktformular. Das Theme rendert den Kaufbereich beim
 * Variantenwechsel aber NICHT neu (siehe assets/product-form.js, #onVariantUpdate holt
 * sich nur den neuen Zustand aus dem Ereignis). Ohne diese Datei bliebe im Warenkorb
 * die Lieferzeit der zuerst gewaehlten Variante stehen.
 *
 * WIE: Auf "variant:update" hoeren (assets/events.js) und den Wert aus der Tabelle
 * neben dem Formular setzen. Hat die neue Variante keine Lieferzeit, wird das Feld
 * entfernt - sonst wuerde eine leere Eigenschaft mitlaufen.
 *
 * Vorbild fuer den Aufbau: assets/lbrgt-produktkennzeichnung.js.
 */

(function () {
  if (window.lbrgtLieferzeitAktiv) return;
  window.lbrgtLieferzeitAktiv = true;

  function tabelleLesen(behaelter) {
    const knoten = behaelter.querySelector("[data-lbrgt-lieferzeit-tabelle]");
    if (!knoten) return null;
    try {
      return JSON.parse(knoten.textContent);
    } catch (_e) {
      return null;
    }
  }

  function setzen(formular, wert) {
    let feld = formular.querySelector("[data-lbrgt-lieferzeit]");

    if (!wert) {
      if (feld) feld.remove();
      return;
    }

    if (!feld) {
      feld = document.createElement("input");
      feld.type = "hidden";
      feld.name = "properties[Lieferzeit]";
      feld.setAttribute("data-lbrgt-lieferzeit", "");
      formular.appendChild(feld);
    }
    feld.value = wert;
  }

  document.addEventListener("variant:update", (event) => {
    const variante = event.detail && event.detail.resource;
    if (!variante || !variante.id) return;

    // Nur Formulare im selben Abschnitt wie das ausloesende Element anfassen.
    const bereich = event.target && event.target.closest ? event.target.closest(".shopify-section") : null;
    const wurzel = bereich || document;

    wurzel.querySelectorAll("form[action*='/cart/add']").forEach((formular) => {
      const tabelle = tabelleLesen(formular) || tabelleLesen(wurzel);
      if (!tabelle) return;
      setzen(formular, tabelle[String(variante.id)] || "");
    });
  });
})();
